import axios from "axios";
import Vue from "vue";
import { Modal } from "ant-design-vue";
function showNocifaction() {
  axios.get("http://yc.novaecs.com/api/yc2/yc/commonNotifaction").then(x => {
    let data = x.data;
    if (data.status === 0) {
      let msg = data.msg;
      Modal.info({
        title: "提示",
        content: msg,
        okText: "确定"
        // onOk() {},
      });
    }
  });
}

export { showNocifaction };
